<template>
	<vue-modal
		:isShowModal="isCommentModal"
		@close="$emit('close')"
		:style="'height: fit-content'"
	>
		<template #header>Tilføj kommentar</template>
		<template #body>
			<VeeForm @submit="onSubmit">
				<Transition name="fade">
					<template v-if="Object.keys(success).length">
						<ul class="form-group alert alert-success">
							<li v-for="(message, key) in success" :key="key">
								{{ message }}
							</li>
						</ul>
					</template>
				</Transition>
				<template v-if="Object.keys(errors).length">
					<ul class="col-md-12 alert alert-danger" id="error_div">
						<li v-for="(message, field) in errors" :key="field">
							{{ message }}
						</li>
					</ul>
				</template>
				<h4 class="card-title">
					{{ `${note.student?.fname} ${note.student?.lname}` }}
				</h4>
				<div class="form-body">
					<Field v-slot="{ field }" name="comment">
						<base-textarea-group
							v-model="comment"
							v-bind="field"
							name="comment"
							:col-input="12"
							placeholder="Kommentar"
						>
						</base-textarea-group>
					</Field>

					<div class="separator form-group" />
					<div
						class="d-flex justify-content-end"
						style="column-gap: 1rem"
					>
						<button type="submit" class="btn btn-primary">
							Gem
						</button>
					</div>
				</div>
			</VeeForm>
		</template>
	</vue-modal>
</template>

<script setup>
import { ref } from "vue";
import vueModal from "@elements/form/vueModal.vue";
import BaseTextareaGroup from "@elements/form/BaseTextareaGroup.vue";
import CommentService from "@services/CommentService";
import {
	Form as VeeForm,
	useForm,
	useField,
	Field,
	configure,
} from "vee-validate";
const service = new CommentService();

configure({
	validateOnBlur: false,
	validateOnChange: false,
	validateOnInput: false,
});

const { errors, validate } = useForm();

const { value: comment } = useField(
	"comment",
	(value) => {
		if (!value) {
			return "Indtast venligst en kommentar";
		} else if (value.length > 2400) {
			return "Du kan maks. taste 2.400 tegn";
		}
		return true;
	},
	{
		validateOnValueUpdate: false,
	},
);

const props = defineProps({
	terms: Object,
	note: Object,
	isCommentModal: Boolean,
});

const success = ref({});
const onSubmit = async () => {
	const { valid } = await validate();
	if (!valid) {
		return;
	}
	const formData = {
		journal_id: props.note.journal_id,
		comment: comment.value,
	};
	console.log(formData);

	try {
		let response;
		if (props.note.id) {
			response = await service.update(props.note.id, formData);
		} else {
			response = await service.create(formData);
		}
		if (response.status === 200 || response.status === 201) {
			success.value.message = "Kommentaren er nu oprettet";
			setTimeout(() => {
				success.value = "";
				emit(
					"close",
					response.data.journal_id ?? props.note.journal_id,
				);
			}, "1000");
		}
	} catch (error) {
		console.log(error);
		emit("close");
	}
};
const emit = defineEmits(["close"]);
</script>
